import { locale } from "../locale"

/**
 * @param {Fencealarm} fa 
 * @returns {string}
 */
function checkLowBatteryAlarm(fa) {
    if (fa.LowBatteryAlarm.Triggered)
        return locale.string({
            enGB: "Low battery",
            deDE: "Schwache Batterie",
            frFR: "Pile faible",
            svSE: "Lågt batteri",
        })

    return ""
}

/**
 * @param {Fencealarm} fa 
 * @returns {string}
 */
function checkOfflineAlarm(fa) {
    if (fa.OfflineAlarm.Triggered)
        return locale.string({
            enGB: "Device offline",
            deDE: "Gerät offline",
            frFR: "Appareil hors ligne",
            svSE: "Enhet offline",
        })

    return ""
}

/**
 * @param {Fencealarm} fa 
 * @returns {string}
 */
function checkVoltageAlarm(fa) {
    if (fa.VoltageAlarm.Enabled && fa.VoltageAlarm.Triggered)
        return locale.string({
            enGB: "Low fence voltage",
            deDE: "Niedrige Zaunspannung",
            frFR: "Faible tension de clôture",
            svSE: "Låg spänning i stängslet",
        })

    return ""
}

/**
 * @param {Fencealarm} fa 
 * @returns {string[]}
 */
function getFencealarmWarnings(fa) {
    return [
        checkLowBatteryAlarm(fa),
        checkOfflineAlarm(fa),
        checkVoltageAlarm(fa),
    ].filter(text => text !== "")
}

export {
    getFencealarmWarnings
}
